import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import {
  InputGroup,
  Button,
  FormControl,
  Col,
  Accordion,
  Card,
  Row,
  Spinner,
  Modal,
  Dropdown,
} from "react-bootstrap";
import _ from "lodash";
import ApiBasketItemPerson from "../../../../core/api/api.basketItemPerson";
import ApiSupplier from "../../../../core/api/api.supplier";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { useNavigate, useLocation } from "react-router-dom";
import { tools } from "../../../../core/utils/tools";
import ShamsiDatePicker from "../../_Components/ShamsiDatePicker";
import SwalMessage from "../../_Components/SwalMessage";
// import ApiOrdersService from "../../../../core/api/api.ordersService";
// import ApiAmusementServiceReserveItem from "../../../../core/api/api.amusementServiceReserveItem";
// import ApiAmusementServiceReserveItemGroup from "../../../../core/api/api.amusementServiceReserveItemGroup";
import ApiAmusementService from "../../../../core/api/api.amusementService";

import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import SelectComponent from "../../_Components/ReactSelectComponent";
import ApiHome from "../../../../core/api/api.home";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";

const receiveOrPayToWarrantyEnumArray = [
  { id: "", title: "-----" },
  { id: "1", title: "دارد" },
  { id: "0", title: "ندارد" },
  { id: "2", title: "بیشتر از یکی" },
];

const promoCodeEnumArray = [
  { id: "", title: "-----" },
  { id: "1", title: "دارد" },
  { id: "0", title: "ندارد" },
];
const Index = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const [services, setServices] = useState([]);
  const [basketItemCurrentStatus, setBasketItemCurrentStatus] = useState([]);
  const [basketCancelStatus, setBasketCancelStatus] = useState([]);
  const [suppliers, setSuppliers] = useState();
  const [commissionSettlementStatus, setCommissionSettlementStatus] = useState(
    []
  );
  const [isExcel, setIsExcel] = useState(false);
  const currentStatus = [
    { id: "0", title: "جدید" },
    { id: "1", title: "در حال پیگیری" },
    { id: "3", title: "انجام شده" },
    { id: "4", title: "انجام نشده" },
  ];
  const cancelStatusOrder = [
     { id: "0", title: "جدید" },
    { id: "1", title: "درخواست کنسلی" },
    { id: "2", title: "پیگیری کنسلی" },
    { id: "3", title: "رهاسازی" },
    { id: "4", title: "کنسل شد" },
    { id: "5", title: "رد درخواست کنسلی" },
  ];
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm();

  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  };
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1)
    ? _.toNumber(pageSizeFromUrl1)
    : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1)
    ? _.toNumber(pageNumberFromUrl1)
    : 1;
  const [groupedReserveItemsOptions, setGroupedReserveItemsOptions] = useState(
    []
  );
  const [group, setGroup] = useState([]);
  const [amusementGroupList, setAmusementGroupList] = useState([]);
  const [amusementCityList, setAmusementCityList] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiBasketItemPerson.getBasketItemPersonsReport({
          pageSize: !_.isEmpty(pageSizeFromUrl)
            ? getValues("pageSize")
            : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl)
            ? getValues("pageNumber")
            : pageNumberFromUrl,
          useTimeOf: searchParams.get("useTimeOf"),
          useTimeTo: searchParams.get("useTimeTo"),
          createTimeOf: searchParams.get("createTimeOf"),
          createTimeTo: searchParams.get("createTimeTo"),
          cancelStatus: _.toString(searchParams.get("cancelStatus")),
          currentStatus: _.toString(searchParams.get("currentStatus")),
          cityIdList: searchParams.get("cityIdList"),
          groupIdList: searchParams.get("groupIdList"),
          amusementServiceIds: searchParams.get("amusementServiceIds"),
          amusementServiceReserveItemIds: searchParams.get(
            "amusementServiceReserveItemIds"
          ),
          amusementServiceReserveItemGroupIds: searchParams.get(
            "amusementServiceReserveItemGroupIds"
          ),
          originalPrice: searchParams.get("originalPrice"),
          salePrice: searchParams.get("salePrice"),
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          basketItemPersonOf: searchParams.get("basketItemPersonOf"),
          basketItemPersonTo: searchParams.get("basketItemPersonTo"),
          basketIdOf: searchParams.get("basketIdOf"),
          basketIdTo: searchParams.get("basketIdTo"),
          payOrReceiveWarrantyTimeOf: searchParams.get(
            "payOrReceiveWarrantyTimeOf"
          ),
          payOrReceiveWarrantyTimeTo: searchParams.get(
            "payOrReceiveWarrantyTimeTo"
          ),
          promoCode: searchParams.get("promoCode"),
          globalSearch: searchParams.get("globalSearch"),
          receiveFromWarrantyCount: searchParams.get(
            "receiveFromWarrantyCount"
          ),
          payToWarrantyCount: searchParams.get("payToWarrantyCount"),
          supplierId: searchParams.get("supplierId"),
          commissionSettlementStatus: searchParams.get(
            "commissionSettlementStatus"
          ),
        });
        setListData(data);
        if (!data.succeeded) {
          SwalMessage({
            title: data.message,
            iSsuccess: false,
            timer: 4000,
          });
          return;
        }
        setValue("totalCount", data.totalCount);
        const amusementService =
          await ApiAmusementService.getAllAmusementServices();
        setServices(amusementService);

        // const resultBasketItemCurrentStatus = await ApiOrdersService.GetEnumsName("BasketItemCurrentStatus");
        // setBasketItemCurrentStatus(resultBasketItemCurrentStatus.data);

        // const resultBasketCancelStatus = await ApiOrdersService.GetEnumsName("BasketCancelStatus");
        // setBasketCancelStatus(resultBasketCancelStatus.data);

        const amusementGroups = await ApiAmusementService.getAllAmusementGroups(
          {}
        );
        setAmusementGroupList(amusementGroups);
        // const cities = await ApiAmusementService.getAllCity();
        // setAmusementCityList(cities);

        const amusementItemIds =
          searchParams.get("amusementServiceIds")?.split(",") || [];

        const selectedServiceIds = amusementService
          .filter((item) => amusementItemIds.includes(String(item.id)))
          ?.map((item) => ({ label: item.name, value: item.id }));

        const selectedItemsGroupIds =
          searchParams.get("amusementServiceReserveItemGroupIds")?.split(",") ||
          [];

        const selectedItemsItemIds =
          searchParams.get("amusementServiceReserveItemIds")?.split(",") || [];

        inputChangeHandlerService(
          selectedServiceIds,
          true,
          selectedItemsGroupIds,
          selectedItemsItemIds
        );
        const mergedGroupedReserveItemsOptions = groupedReserveItemsOptions
          .map((item) => item.options)
          .flat();

        const formInputs = [
          { name: "originalPrice", type: "text" },
          { name: "salePrice", type: "text" },
          { name: "useTimeOf", type: "datePicker" },
          { name: "useTimeTo", type: "datePicker" },
          { name: "createTimeOf", type: "datePicker" },
          { name: "createTimeTo", type: "datePicker" },
          { name: "firstName", type: "text" },
          { name: "lastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "basketItemPersonOf", type: "text" },
          { name: "basketItemPersonTo", type: "text" },
          { name: "basketIdOf", type: "text" },
          { name: "basketIdTo", type: "text" },
          {
            name: "payOrReceiveWarrantyTimeOf",
            type: "datePicker"
          },
          {
            name: "payOrReceiveWarrantyTimeTo",
            type: "datePicker"
          },

          {
            name: "promoCode",
            type: "multiSelect",
             isMulti: true,
            data: promoCodeEnumArray,
          },
          {
            name: "currentStatus",
            type: "multiSelect",
            isMulti: true,
            data: currentStatus,
          },
          // { name: "cityIdList", type: "multiSelect", data: cities },
          {
            name: "groupIdList",
            type: "multiSelect",
            isMulti: true,
            data: amusementGroups.data,
          },
          {
            name: "amusementServiceReserveItemGroupIds",
            type: "multiSelect",
            isMulti: true,
            data: mergedGroupedReserveItemsOptions?.map((optionItem) => ({
              id: optionItem.value,
              title: optionItem.label,
            })),
          },
          {
            name: "cancelStatus",
            type: "multiSelect",
            isMulti: true,
            data: cancelStatusOrder,
          },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          {
            name: "receiveFromWarrantyCount",
            type: "multiSelect",
            isMulti: true,
            data: receiveOrPayToWarrantyEnumArray,
          },
          {
            name: "payToWarrantyCount",
            type: "multiSelect",
            isMulti: true,
            data: receiveOrPayToWarrantyEnumArray,
          },
          {
            name: "supplierId",
            type: "multiSelect",
            isMulti: true,
            data: suppliers?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
          // {
          //   name: "commissionSettlementStatus",
          //   type: "multiSelect",
          //   data: commissionSettlementStatusList?.data?.map((item) => ({ id: item.value, title: item.title })),
          // },
          {
            name: "amusementServiceIds",
            type: "multiSelect",
            isMulti: true,
            data: amusementService,
          },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => { };
  }, []);

  const inputChangeHandlerService = async (
    event,
    firstRender = false,
    selectedItemsGroupIds = [],
    selectedItemsItemIds = []
  ) => {
    if (!firstRender) setValue("amusementServiceIds", event);
  
    if (event.length > 0) {
      const responses = await Promise.all(
        event.map(async ({ value }) => {
            const reserveItems = await ApiAmusementService.getAmusementReserveItem({
                serviceId: value,
            });
            const reserveItemGroups = await ApiAmusementService.getAmusementReserveItemGroup({
                serviceId: value,
            });
            return [reserveItems.data, reserveItemGroups.data, value];
        })
      );
  
      let groupedReserveItemsOptions = [];
      let groupedReserveItemGroupOptions = [];
      let itemList = [];
      let groupList = [];
  
      responses.forEach(([reserveItems, reserveItemGroups, value]) => {
        const label = event.find((item) => item.value == value)?.label;
  
        const optionsItems = reserveItems.map((item) => ({
          value: item.id,
          label: item.title,
        }));
  
        const optionsGroups = reserveItemGroups.map((item) => ({
          value: item.id,
          label: item.title,
        }));
  
        groupedReserveItemsOptions.push({ label, options: optionsGroups }); // گروه آیتم‌ها
        groupedReserveItemGroupOptions.push({ label, options: optionsItems }); // آیتم‌ها
  
        if (firstRender) {
          const selectedGroupItems = reserveItemGroups
            .filter((item) => selectedItemsGroupIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));
  
          const selectedItems = reserveItems
            .filter((item) => selectedItemsItemIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));
  
          itemList.push(...selectedGroupItems);
          groupList.push(...selectedItems);
        }
      });
      setGroupedReserveItemsOptions(groupedReserveItemsOptions);
      setGroup(groupedReserveItemGroupOptions);
  
      if (firstRender) {
          setValue("amusementServiceReserveItemGroupIds", itemList);
          setValue("amusementServiceReserveItemIds", groupList);
      }
    } else if (event.length === 0) {
      // وقتی هیچ تفریحی انتخاب نشده
      setGroupedReserveItemsOptions([]);
      setGroup([]);
      setValue("amusementServiceReserveItemGroupIds", []);
      setValue("amusementServiceReserveItemIds", []);
    }
  };

  const onSubmit = async (data) => {
    // if (data.cityIdList?.length > 0) data.cityIdList = _.toString(data.cityIdList?.map((item) => item.value));
    if (data.groupIdList?.length > 0)
      data.groupIdList = _.toString(
        data.groupIdList?.map((item) => item.value)
      );
    if (
      !_.isEmpty(data.originalPrice) &&
      !validateNumberOriginalPrice(data.originalPrice)
    )
      return;
    if (!_.isEmpty(data.salePrice) && !validateNumberSalePrice(data.salePrice))
      return;
    if (
      !_.isEmpty(data.basketItemPersonOf) &&
      !validateNumberBasketItemPersonOf(data.basketItemPersonOf)
    )
      return;
    if (
      !_.isEmpty(data.basketItemPersonTo) &&
      !validateNumberBasketItemPersonTo(data.basketItemPersonTo)
    )
      return;
    if (
      !_.isEmpty(data.basketIdOf) &&
      !validateNumberBasketIdOf(data.basketIdOf)
    )
      return;
    if (
      !_.isEmpty(data.basketIdTo) &&
      !validateNumberBasketIdTo(data.basketIdTo)
    )
      return;

    // data.supplierId = data.supplierId?.value;
    // data.promoCode = data.promoCode?.value;
    // data.commissionSettlementStatus = data.commissionSettlementStatus?.value;
    // data.payToWarrantyCount = data.payToWarrantyCount?.value;
    // data.receiveFromWarrantyCount = data.receiveFromWarrantyCount?.value;

    if (data.currentStatus?.length > 0) {
      data.currentStatus = _.toString(
        data.currentStatus.map((item) => item.value)
      );
      // اگر  شامل 'جدید' بود، 'رهاسازی' را اضافه کن
      // if (data.currentStatus.includes("0")) {
      //   data.currentStatus += ",2";
      // }
    }
    if (data.cancelStatus?.length > 0) {
      data.cancelStatus = _.toString(
        data.cancelStatus.map((item) => item.value)
      );
      // اگر شامل "درخواست کنسلی" بود، 'رهاسازی' را اضافه کن
      // if (data.cancelStatus.includes("1")) {
      //   data.cancelStatus += ",3";
      // }
    }

    if (data.amusementServiceIds?.length > 0)
      data.amusementServiceIds = _.toString(
        data.amusementServiceIds?.map((item) => item.value)
      );

    if (data.amusementServiceReserveItemGroupIds?.length > 0)
      data.amusementServiceReserveItemGroupIds = _.toString(
        data.amusementServiceReserveItemGroupIds?.map((item) => item.value)
      );

    if (data.amusementServiceReserveItemIds?.length > 0)
      data.amusementServiceReserveItemIds = _.toString(
        data.amusementServiceReserveItemIds?.map((item) => item.value)
      );

    if (
      data.payOrReceiveWarrantyTimeOf !== null &&
      typeof data.payOrReceiveWarrantyTimeOf === "object"
    ) {
      data.payOrReceiveWarrantyTimeOf = tools.DateFormat(
        data.payOrReceiveWarrantyTimeOf
      );
    }
    if (
      data.payOrReceiveWarrantyTimeTo !== null &&
      typeof data.payOrReceiveWarrantyTimeTo === "object"
    ) {
      data.payOrReceiveWarrantyTimeTo = tools.DateFormat(
        data.payOrReceiveWarrantyTimeTo
      );
    }
    if (data.useTimeOf !== null && typeof data.useTimeOf === "object") {
      data.useTimeOf = tools.DateFormat(data.useTimeOf);
    }
    if (data.useTimeTo !== null && typeof data.useTimeTo === "object") {
      data.useTimeTo = tools.DateFormat(data.useTimeTo);
    }
    if (data.createTimeOf !== null && typeof data.createTimeOf === "object") {
      data.createTimeOf = tools.DateFormat(data.createTimeOf);
    }
    if (data.createTimeTo !== null && typeof data.createTimeTo === "object") {
      data.createTimeTo = tools.DateFormat(data.createTimeTo);
    }
    if (!_.isEmpty(data.salePrice))
      data.salePrice = data.salePrice.replaceAll(",", "");
    if (!_.isEmpty(data.originalPrice))
      data.originalPrice = data.originalPrice.replaceAll(",", "");
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiBasketItemPerson.getBasketItemPersonsReport(data);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount"])
    );
    navigate(`/sellReport?${queryString}`);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
  };

  function handleChangeMultiCurrentStatus(value, selectItem) {
    setValue("currentStatus", value);
  }
  function handleChangeMultiCancelStatus(value, selectItem) {
    setValue("cancelStatus", value);
  }

  const validateNumberOriginalPrice = (value) => {
    if (
      Number(value) > 2147483647 ||
      value.includes(".") ||
      value.includes("-")
    ) {
      setError("originalPrice", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("originalPrice");
      return true;
    }
  };

  const validateNumberSalePrice = (value) => {
    if (
      Number(value) > 2147483647 ||
      value.includes(".") ||
      value.includes("-")
    ) {
      setError("salePrice", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("salePrice");
      return true;
    }
  };

  const validateNumberBasketItemPersonOf = (value) => {
    if (
      Number(value) > 2147483647 ||
      value.includes(".") ||
      value.includes("-")
    ) {
      setError("basketItemPersonOf", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonOf");
      return true;
    }
  };
  const validateNumberBasketItemPersonTo = (value) => {
    if (
      Number(value) > 2147483647 ||
      value.includes(".") ||
      value.includes("-")
    ) {
      setError("basketItemPersonTo", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonTo");
      return true;
    }
  };

  const validateNumberBasketIdOf = (value) => {
    if (
      Number(value) > 2147483647 ||
      value.includes(".") ||
      value.includes("-")
    ) {
      setError("basketIdOf", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketIdOf");
      return true;
    }
  };
  const validateNumberBasketIdTo = (value) => {
    if (
      Number(value) > 2147483647 ||
      value.includes(".") ||
      value.includes("-")
    ) {
      setError("basketIdTo", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketIdTo");
      return true;
    }
  };

  return (
    <div>
      <div className={`card card-custom`}>
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              گزارش فروش
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              صورت معاملات دوره ای
            </span>
          </h3>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}

              <div className="border-top pt-3">
                {/* {Serach} */}
                <Accordion>
                  <Card>
                    <Accordion.Header
                      as={Card.Header}
                      variant="link"
                      eventKey="0"
                    >
                      <Card.Title className="py-0 pl-0 text-gray fs-normal">
                        جستجو پیشرفته
                      </Card.Title>
                    </Accordion.Header>
                    <Accordion.Body eventKey="0">
                      <Card.Body>
                        <Row>
                          {/* <Col
                            sm="6"
                            xl="3"
                            className="tb-responsive px-2 mt-5"
                          >
                            <Controller
                              name="createTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => {
                                return (
                                  <ShamsiDatePicker
                                    value={value}
                                    onChange={(date) => {
                                      var createTimeTo =
                                        getValues("createTimeTo");
                                      onChange(date);
                                      if (
                                        !createTimeTo ||
                                        date?.toDate()?.getTime() >
                                          new Date(createTimeTo).getTime()
                                      ) {
                                        // Set the value of createTimeTo to the same as createTimeTo
                                        setValue("createTimeTo", date);
                                      }
                                    }}
                                    placeholder="زمان ایجاد از"
                                  />
                                );
                              }}
                            />
                          </Col>
                          <Col sm="6" xl="3" className=" px-2 mt-5">
                            <Controller
                              name="createTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={onChange}
                                  placeholder="زمان ایجاد تا"
                                />
                              )}
                            />
                          </Col> */}

                          <Col sm="6" xl="3" className=" px-2 mt-5">
                            <Controller
                              name="useTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={(date) => {
                                    var useTimeTo = getValues("useTimeTo");
                                    onChange(date);
                                    if (
                                      !useTimeTo ||
                                      date?.toDate()?.getTime() >
                                      new Date(useTimeTo).getTime()
                                    ) {
                                      // Set the value of useTimeTo to the same as useTimeOf
                                      setValue("useTimeTo", date);
                                    }
                                  }}
                                  placeholder="زمان انجام تفریح از"
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className=" px-2 mt-5">
                            <Controller
                              name="useTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={onChange}
                                  placeholder="زمان انجام تفریح تا"
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="currentStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="وضعیت سفارش"
                                  options={[
                                    ...currentStatus.map((item) => ({
                                      value: item.id,
                                      label: item.title,
                                    })),
                                  ]}
                                  onChange={handleChangeMultiCurrentStatus}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className=" px-2 mt-5">
                            <Controller
                              name="cancelStatus"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-0"
                                  placeholder="وضعیت کنسلی"
                                  options={[
                                    ...cancelStatusOrder.map((item) => ({
                                      value: item.id,
                                      label: item.title,
                                    })),
                                  ]}
                                  field={field}
                                  onChange={handleChangeMultiCancelStatus}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="originalPrice"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="نرخ مصوب "
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  error={!!errors.originalPrice}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberOriginalPrice(values.value);
                                  }}
                                />
                              )}
                            />
                            {errors.originalPrice && (
                              <div className="text-small-1 text-danger">
                                {" "}
                                {errors.originalPrice.message}
                              </div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="salePrice"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="نرخ فروش "
                                  className="mt-3 mt-sm-5"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  error={!!errors.salePrice}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberSalePrice(values.value);
                                  }}
                                />
                              )}
                            />
                            {errors.salePrice && (
                              <div className="text-small-1 text-danger">
                                {" "}
                                {errors.salePrice.message}
                              </div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="basketItemPersonOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره بلیط از "
                                  size="small"
                                  className="mt-3 mt-xl-5"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketItemPersonOf}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonOf(
                                      values.value
                                    );
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonOf && (
                              <div className="text-small-1 text-danger">
                                {" "}
                                {errors.basketItemPersonOf.message}
                              </div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="basketItemPersonTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره بلیط تا "
                                  size="small"
                                  className="mt-3 mt-xl-5"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketItemPersonTo}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonTo(
                                      values.value
                                    );
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonTo && (
                              <div className="text-small-1 text-danger">
                                {" "}
                                {errors.basketItemPersonTo.message}
                              </div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="basketIdOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="شماره سفارش از"
                                  className="mt-3"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketIdOf}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketIdOf(values.value);
                                  }}
                                />
                              )}
                            />
                            {errors.basketIdOf && (
                              <div className="text-small-1 text-danger">
                                {" "}
                                {errors.basketIdOf.message}
                              </div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="basketIdTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  className="mt-3"
                                  label="شماره سفارش تا"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketIdTo}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketIdTo(values.value);
                                  }}
                                />
                              )}
                            />
                            {errors.basketIdTo && (
                              <div className="text-small-1 text-danger">
                                {" "}
                                {errors.basketIdTo.message}
                              </div>
                            )}
                          </Col>
                          {/* <Col sm="6" xl="3" className="px-2 ">
                            <Controller
                              name="cityIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className=" mt-2"
                                  placeholder=" شهر"
                                  options={amusementCityList?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.name,
                                  }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col> */}
                          <Col sm="6" xl="3" className="px-2 ">
                            <Controller
                              name="groupIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5 mt-sm-2"
                                  placeholder=" دسته تفریح"
                                  options={amusementGroupList?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="  px-2 ">
                            <Controller
                              name="amusementServiceIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5 mt-sm-3 mt-xl-2"
                                  placeholder="تفریح"
                                  options={services?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.name,
                                  }))}
                                  field={field}
                                  onChange={(e) => inputChangeHandlerService(e)}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="  px-2">
                            <Controller
                              name="amusementServiceReserveItemGroupIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-5 mt-sm-5 mt-xl-2"
                                  placeholder="گروه آیتم"
                                  options={groupedReserveItemsOptions || []}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="  px-2">
                            <Controller
                              name="amusementServiceReserveItemIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-5 mt-sm-5 mt-xl-2"
                                  placeholder="آیتم"
                                  options={group || []}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="firstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام"
                                  className="mt-5 mt-xl-3"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onChange={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  className="mt-2 mt-sm-5 mt-xl-3"
                                  label="نام خانوادگی"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onChange={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className=" px-2">
                            <Controller
                              name="phoneNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  className="mt-2  mt-xl-3"
                                  customInput={TextField}
                                  label="شماره موبایل"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  onChange={onChange}
                                />
                              )}
                            />
                          </Col>

                          <Col
                            sm="6"
                            xl="3"
                            className=" px-2 mt-3 mt-sm-2 mt-xl-3"
                          >
                            <Controller
                              name="payOrReceiveWarrantyTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={(date) => {
                                    var payOrReceiveWarrantyTimeTo = getValues(
                                      "payOrReceiveWarrantyTimeTo"
                                    );
                                    onChange(date);
                                    if (
                                      !payOrReceiveWarrantyTimeTo ||
                                      date?.toDate()?.getTime() >
                                      new Date(
                                        payOrReceiveWarrantyTimeTo
                                      ).getTime()
                                    ) {
                                      // Set the value of payOrReceiveWarrantyTimeTo to the same as useTimeOf
                                      setValue(
                                        "payOrReceiveWarrantyTimeTo",
                                        date
                                      );
                                    }
                                  }}
                                  placeholder="زمان تسویه از"
                                />
                              )}
                            />
                          </Col>
                          <Col
                            sm="6"
                            xl="3"
                            className=" px-2 mt-5 mt-sm-2 mt-xl-3"
                          >
                            <Controller
                              name="payOrReceiveWarrantyTimeTo"
                              control={control}
                              render={({ field }) => (
                                <ShamsiDatePicker
                                  {...field}
                                  placeholder="زمان تسویه تا"
                                />
                              )}
                            />
                          </Col>
                        </Row>

                        <Row className="">
                          <Col xs="12" className=" px-2 mt-3">
                            <Button
                              variant="success"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(false);
                              }}
                            >
                              {isSubmitting && (
                                <Spinner
                                  animation="border"
                                  variant="warning"
                                  size="sm"
                                />
                              )}
                              <SearchIcon />
                              جستجو
                            </Button>

                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(false);
                                tools.handleResetAdvanceSearchBox(watch, reset);
                              }}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                            {/* <Button
                              className="ml-4"
                              variant="info"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(true);
                              }}
                            >
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <InsertDriveFile /> فایل اکسل
                            </Button> */}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <FormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting && (
                      <Spinner animation="border" variant="warning" size="sm" />
                    )}
                    <SearchIcon />{" "}
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className=" px-0">
                <DataGrid data={listData} />
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Index;
